<app-master-detail-layout
    [isMobile]="isMobile"
    [showDetail]="showDetailMobile"
    (backToSidebar)="goBack()"
>
    
    <span sidebarTitle #sidebarTitle>{{'FIDELITY.SETUP.RULES.TITLE' | translate}}</span>

    <div sidebarActions #sidebarActions>
        <button mat-icon-button
            (click)="addRule()"
        >
            <mat-icon>add</mat-icon>
        </button>
    </div>

    <div sidebar>
        @for(rule of rulesList; track rule.id; let i = $index) {
            <app-sidebar-item
                [isSelected]="isSelected(rule)"
                (click)="selectRule($event, i)"
            >
                <span title #title>{{ rule.name }}</span>
            </app-sidebar-item>
        }
    </div>

    <div headerTitle class="tw-w-full tw-min-w-0">
        @if(isNotEmptyState) { 
            <span class="tw-w-full" [appTruncatedText]="ruleFormService.name?.value || ''"
            >{{ruleFormService.name?.value || ('FIDELITY.SETUP.RULES.PLACEHOLDER_NAME' | translate)}}</span>
        }
    </div>

    <ng-container actions>
        @if(isNotEmptyState) { 
            @if(selectedRule?.id) {
                <app-action-btn variant="basic" 
                    (click)="deleteRule()"
                >
                Elimina
                </app-action-btn>
            }
    
            <app-action-btn
                [disabled]="!ruleForm.valid"
                (click)="saveRule()"
            >
            Salva
            </app-action-btn>
        }
    </ng-container>

    <ng-container content>
        @if(isNotEmptyState) {
            <app-card [fullWidth]="true" [withCard]="false">
                <form autocomplete="off" [formGroup]="ruleForm"
                        class="form tw-flex tw-flex-col tw-gap-5">
                    <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3">
                
                        <mat-form-field class="tw-col-span-12 lg:tw-col-span-4">
                            <mat-label translate>FIDELITY.SETUP.RULES.NAME</mat-label>
                            <input matInput formControlName="name" appTrimInput>
                            <mat-hint [align]="'end'">{{ruleFormService.name?.value?.length || '0'}}
                                / {{ruleFormService.validators.nameMaxLength}}</mat-hint>
                            @if(ruleFormService.name?.hasError('maxlength')) {
                                <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{ruleFormService.validators.nameMaxLength}})</mat-error>
                            } @else if(ruleFormService.name?.hasError('required')) {
                                <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                            }
                        </mat-form-field>

                        <mat-form-field class="tw-col-span-12 lg:tw-col-span-4 md:tw-col-span-6">
                            <mat-label translate>FIDELITY.SETUP.RULES.POINTS</mat-label>
                            <input matInput type="number" formControlName="points"
                                [min]="1">
                            @if(ruleFormService.points?.hasError('required')) {
                                <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                            }
                        </mat-form-field>
                
                        <mat-form-field class="tw-col-span-12 lg:tw-col-span-4 md:tw-col-span-6">
                            <mat-label translate>FIDELITY.SETUP.RULES.TYPE</mat-label>
                            <mat-select formControlName="type">
                                @for(rule of ruleTypes; track rule.value) {
                                    <mat-option [value]="rule.value">{{rule.name}}</mat-option>
                                }
                            </mat-select>
                            @if(ruleFormService.type?.hasError('required')) {
                                <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                            }
                        </mat-form-field>

                        <mat-form-field class="tw-col-span-12 lg:tw-col-span-4 md:tw-col-span-6">
                            <mat-label translate>FIDELITY.SETUP.RULES.MIN_THRESHOLD</mat-label>
                            <input matInput type="number" formControlName="min_threshold"
                                [min]="1">
                        </mat-form-field>

                        <mat-form-field class="tw-col-span-12 lg:tw-col-span-4 md:tw-col-span-6">
                            <mat-label translate>FIDELITY.SETUP.RULES.MAX_THRESHOLD</mat-label>
                            <input matInput type="number" formControlName="max_threshold"
                                [min]="1">
                        </mat-form-field>
                        

                        <div class="tw-col-span-12 tw-flex lg:tw-col-span-4 md:tw-col-span-6">
                            <mat-slide-toggle formControlName="exclude_to_min" aria-label="{{'FIDELITY.SETUP.RULES.EXCLUDE_TO_MIN' | translate}}"
                                class="tw-p-3">{{'FIDELITY.SETUP.RULES.EXCLUDE_TO_MIN' | translate}}</mat-slide-toggle>
                        </div>

                        <mat-form-field class="tw-col-span-12 lg:tw-col-span-4 md:tw-col-span-6">
                            <mat-label>{{("FIDELITY.SETUP.RULES.PARAMETER" | translate : {value: '1'})}}</mat-label>
                            <input matInput formControlName="param1" appTrimInput>
                        </mat-form-field>
                    </section>
                </form>
            </app-card>
        } @else {
            <ng-container *ngTemplateOutlet="emptyState"></ng-container>
        }
    </ng-container>
</app-master-detail-layout>

<ng-template #emptyState>
    <section class="lg:tw-col-span-2 tw-col-span-1 tw-h-full tw-block">
        <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-flex-1 tw-text-center">
            <div class="tw-bg-slate-50 tw-rounded-full tw-p-2 tw-text-slate-400">
                <mat-icon class="!tw-w-24 !tw-h-24 tw-text-[96px]">ads_click</mat-icon>
            </div>
            <h3 class="tw-font-semibold tw-text-slate-500 tw-max-w-md">
                {{ 'FIDELITY.SETUP.RULES.RULE_NOT_SELECTED_MSG' | translate }}
            </h3>
        </div>
    </section>
</ng-template>